import { render, staticRenderFns } from "./CalculationTotals.vue?vue&type=template&id=4cfb5567&"
import script from "./CalculationTotals.vue?vue&type=script&lang=ts&"
export * from "./CalculationTotals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports